import {
  BarChart3,
  CalendarPlus,
  CheckCircle2,
  FileText,
  LayoutDashboard,
  LayoutGrid,
  ListChecks,
  Megaphone,
  Tags,
  Users,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: LucideIcon;
  end?: boolean;
  /** ads resource slug for admin RBAC gating (omit = always shown). */
  slug?: string;
}

export const advertiserNav: NavItem[] = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/campaigns', label: 'Campaigns', icon: Megaphone },
  { to: '/book', label: 'Book Ads', icon: CalendarPlus },
  { to: '/wallet', label: 'Wallet', icon: Wallet },
  { to: '/invoices', label: 'Invoices', icon: FileText },
  { to: '/reports', label: 'Reports', icon: BarChart3 },
];

export const adminNav: NavItem[] = [
  { to: '/admin', label: 'Overview', icon: LayoutDashboard, end: true, slug: 'ads.overview' },
  { to: '/admin/approvals', label: 'Approvals', icon: CheckCircle2, slug: 'ads.approvals' },
  { to: '/admin/advertisers', label: 'Advertisers', icon: Users, slug: 'ads.advertisers' },
  { to: '/admin/bookings', label: 'Bookings', icon: ListChecks, slug: 'ads.bookings' },
  { to: '/admin/rate-card', label: 'Rate Card', icon: Tags, slug: 'ads.rate-card' },
  { to: '/admin/inventory', label: 'Inventory', icon: LayoutGrid, slug: 'ads.inventory' },
  { to: '/admin/reports', label: 'Reports', icon: BarChart3, slug: 'ads.reports' },
];
